<template>
  <div class="wg-row">
    <!-- new user dialog -->
    <wg-modal v-if="showUserDialog" @closeModal="showUserDialog = false">
      <div slot="header" class="com-anm22-app-text-xl">
        {{ $anm22.strLang(lang, 'New user', 'Nuovo utente') }}
      </div>
      <div slot="body" class="wg-row" style="justify-content:center;">
        <div class="com-anm22-app-text-l">
          {{ $anm22.strLang(lang, 
              'User not found. You can create a new user with the form below.', 
              'Utente non trovato. È possibile creare un nuovo utente inserendo i seguenti dati.'
          )}}
        </div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <template v-if="newUserErrors.length > 0">
          <div v-if="newUserErrors.includes('name')" class="com-anm22-app-text-l" style="margin-top:5px;">
            {{ $anm22.strLang(lang, 'Invalid name', 'Nome non valido') }}
          </div>
          <div v-if="newUserErrors.includes('surname')" class="com-anm22-app-text-l" style="margin-top:5px;">
            {{ $anm22.strLang(lang, 'Invalid surname', 'Cognome non valido') }}
          </div>
          <div v-if="newUserErrors.includes('email')" class="com-anm22-app-text-l" style="margin-top:5px;">
            {{ $anm22.strLang(lang, 'Invalid email', 'Email non valida') }}
          </div>
          <div v-if="newUserErrors.includes('password')" class="com-anm22-app-text-l" style="margin-top:5px;">
            {{ $anm22.strLang(lang, 'Invalid password', 'Password non valida') }}
          </div>
          <div class="vertical-height-div" style="height:5px;"></div>
        </template>
        <div class="com-anm22-app-text-l">
          {{ $anm22.strLang(lang, 'Name', 'Nome')}}
        </div>
        <div class="vertical-height-div" style="height:5px;"></div>
        <input 
            class="com-anm22-app-input-text"
            type="text"
            :placeholder="$anm22.strLang(lang, 'Name', 'Nome')"
            v-model="newUser.name">
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="com-anm22-app-text-l">
          {{ $anm22.strLang(lang, 'Surname', 'Cognome')}}
        </div>
        <div class="vertical-height-div" style="height:5px;"></div>
        <input 
            class="com-anm22-app-input-text"
            type="text"
            :placeholder="$anm22.strLang(lang, 'Surname', 'Cognome')"
            v-model="newUser.surname">
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="com-anm22-app-text-l">
          Email
        </div>
        <div class="vertical-height-div" style="height:5px;"></div>
        <input 
            class="com-anm22-app-input-text"
            type="email"
            :placeholder="'Email'"
            v-model="newUser.email">
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="com-anm22-app-text-l">
          {{ $anm22.strLang(lang, 'Password', 'Password')}}
        </div>
        <div class="vertical-height-div" style="height:5px;"></div>
        <input 
            class="com-anm22-app-input-text"
            type="password"
            :placeholder="$anm22.strLang(lang, 'Password', 'Password')"
            v-model="newUser.password">
        <div class="vertical-height-div" style="height:10px;"></div>
        <input 
            type="button" 
            :value="$anm22.strLang(lang, 'Save', 'Salva')" 
            @click="createUser">
      </div>
    </wg-modal>
    <!-- Dialog modifica -->
    <wg-modal v-if="showAdminDialog" @closeModal="closeAdminDialog">
      <div slot="header" class="com-anm22-app-text-xl">
        {{ $anm22.strLang(lang, 'Edit administrator', 'Modifica amministratore') }}
      </div>
      <div slot="body" class="wg-row" style="justify-content:center;">
        <div class="com-anm22-app-text-l">
          {{ $anm22.strLang(lang, 'Permission', 'Permesso')}}
        </div>
        <div class="vertical-height-div" style="height:5px;"></div>
        <select class="com-anm22-app-select" v-model="selected.permission">
          <option 
              v-for="(obj, key, index) in permissionList"
              :key="'permission-'+index"
              :value="key">
            {{ obj[lang] }}
          </option>
        </select>  
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="com-anm22-app-text-l">
          PIN
        </div>
        <div class="vertical-height-div" style="height:5px;"></div>
        <input 
            class="com-anm22-app-input-text"
            type="password"
            placeholder="PIN"
            v-model="selected.pin">
        <div class="vertical-height-div" style="height:10px;"></div>
        <input 
            type="button" 
            :value="$anm22.strLang(lang, 'Save', 'Salva')" 
            @click="edit">
      </div>
    </wg-modal>
    <!-- 
      Modal conferma cancellazione
    -->
    <wg-modal v-if="showDeleteDialog" @closeModal="closeDeleteDialog">
      <div class="wg-row" style="justify-content:center;" slot="body">
        <div
          class="com-anm22-app-text-xl"
        >{{ $anm22.strLang(lang, 'Delete administrator?', 'Cancellare amministratore?') }}</div>
        <div class="vertical-height-div" style="height:20px;"></div>
        <div class="wg-row" style="align-items:center;justify-content:center;">
          <input
            type="button"
            class="small com-anm22-button-blue"
            :value="$anm22.strLang(lang, 'OK', 'OK')"
            @click="deleteAdmin"
          >
          <div class="com-anm22-app-horizontal-space" style="width:20px;"></div>
          <input
            type="button"
            class="small com-anm22-button-red"
            :value="$anm22.strLang(lang, 'Cancel', 'Annulla')"
            @click="closeDeleteDialog"
          >
        </div>
      </div>
    </wg-modal>
    <div class="com-anm22-page-title" style="font-size:24px;">
      {{ $anm22.strLang(lang, 'Administrators', 'Lista amministratori') }}
    </div>
    <div class="vertical-height-div" style="height:10px;"></div>
    <div class="wg-row" style="flex-direction:column;">
      <div 
          v-for="(e,i) in employmentsList"
          :key="'admin-'+i"
          class="wg-row"
          style="flex-wrap:nowrap;align-items:center;margin-bottom:10px;max-width:600px;">
        <div class="wg-col wg-xs-2 wg-sm-1" style="padding:0 5px;">
          <div class="wg-row" style="justify-content:center;flex-wrap:nowrap;align-items:center;">
            <div style="min-width:50px;width:50px;height:50px;margin-right:10px;">
              <world-object-icon
                  :type="'user'" 
                  :obj="e.user"
                  :isImg="true">
              </world-object-icon>
            </div>
          </div>
        </div>
        <div class="wg-col wg-xs-8 wg-sm-9" style="padding:0 5px;">
          <div class="wg-row" style="flex-direction:column;justify-content:center;">
            <div class="wg-row">
              <div class="com-anm22-app-text-xl" style="overflow:hidden;white-space:nowrap;text-overflow:ellipsis;">{{ e.user.name + ' ' + e.user.surname }}</div>
            </div>
            <div class="vertical-height-div" style="height:2px;"></div>
            <template v-if="e.permission > 1">
              <div class="wg-row">
                <div class="com-anm22-app-text-l" style="overflow:hidden;white-space:nowrap;text-overflow:ellipsis;">{{ e.user.email }}</div>
              </div>
              <div class="vertical-height-div" style="height:2px;"></div>
              <div class="wg-row">
                <div class="com-anm22-app-text-l" style="overflow:hidden;white-space:nowrap;text-overflow:ellipsis;">{{ $anm22.tableClasses.foodPermission().getById(e.permission)[lang] }}</div>
              </div>
            </template>
            <div v-else class="support-label">Support</div>
          </div>
        </div>
        <div class="wg-col wg-xs-1" style="padding:0 5px;">
          <div class="wg-row" style="justify-content:center;flex-wrap:nowrap;align-items:center;">
            <img 
                v-if="permission <= e.permission"
                :src="$anm22.icons.getWorldIcon('edit')"
                class="com-anm22-app-img-s"
                style="cursor:pointer;"
                @click="openAdminDialog(e)"
            >
          </div>
        </div>
        <div class="wg-col wg-xs-1" style="padding:0 5px;">
          <div class="wg-row" style="justify-content:center;flex-wrap:nowrap;align-items:center;">
            <img 
                v-if="employments.length > 1 && permission <= e.permission"
                :src="$anm22.icons.getWorldIcon('deleteBlack')"
                class="com-anm22-app-img-s"
                style="cursor:pointer;"
                @click="openDeleteDialog(e)"
            >
          </div>
        </div>
      </div>
    </div>
    <div class="vertical-height-div" style="height:20px;"></div>
    <!-- Form aggiunta admin -->
    <div class="com-anm22-app-text-xxl">
      {{ $anm22.strLang(lang, 'Add administrator', 'Aggiungi amministratore') }}
    </div>
    <div class="vertical-height-div" style="height:10px;"></div>
    <div class="com-anm22-app-text-l">
      E-mail
    </div>
    <div class="vertical-height-div" style="height:5px;"></div>
    <div class="wg-row">
      <input 
          class="com-anm22-app-input-text"
          type="text"
          placeholder="Email"
          v-model="newAdmin.email">   
    </div>
    <div class="vertical-height-div" style="height:10px;"></div>
    <div class="com-anm22-app-text-l">
      {{ $anm22.strLang(lang, 'Permission', 'Permesso')}}
    </div>
    <div class="vertical-height-div" style="height:5px;"></div>
    <div class="wg-row">
      <select class="com-anm22-app-select" v-model="newAdmin.permission">
        <option 
            v-for="(obj, key, index) in permissionList"
            :key="'permission-'+index"
            :value="key">
          {{ obj[lang] }}
        </option>
      </select>  
    </div>
    <div class="vertical-height-div" style="height:10px;"></div>
    <div class="com-anm22-app-text-l">
      PIN
    </div>
    <div class="vertical-height-div" style="height:5px;"></div>
    <div class="wg-row">
      <input 
          class="com-anm22-app-input-text"
          type="password"
          placeholder="PIN"
          v-model="newAdmin.pin">
    </div>
    <div class="vertical-height-div" style="height:10px;"></div>
    <div class="wg-row">
      <input 
          type="button" 
          :value="$anm22.strLang(lang, 'Add', 'Aggiungi')" 
          @click="add">
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  data() {
    return {
      showAdminDialog: false,
      showDeleteDialog: false,
      selected: null,
      newAdmin: {
        email: '',
        permission: 5,
        pin: ''
      },
      showUserDialog: false,
      newUser: {
        name: '',
        surname: '',
        email: '',
        pass: ''
      },
      newUserErrors: []
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      lang: state => state.lang,
      licenseSelected: state => state.licenseSelected,
      windowWidth: state => state.windowWidth,
      windowHeight: state => state.windowHeight,
      isOffline: state => state.offline.isOffline
    }),
    license() {
      return this.$store.getters['foodLicenses/getByHash'](this.licenseSelected);
    },
    employment() {
      return this.$store.getters["foodEmployments/get"](
        this.license.id + "-" + this.user.idWorldUser
      );
    },
    permission() {
      return this.employment ? this.employment.permission : 6;
    },
    employments() {
      return this.$store.getters['foodEmployments/getByLicense'](this.license.id);
    },
    employmentsList() {
      return this.employments
        .map(e => {
          return {
            ...e,
            user: this.$store.getters['users/get'](e.administrator)
          }
        })
        .sort((a,b) => {
          if (a.permission < b.permission) return -1;
          if (a.permission > b.permission) return 1;
          if (a.user.name < b.user.name) return -1;
          if (a.user.name > b.user.name) return 1;
          return 0;
        });
    },
    permissionList() {
      const permissions = this.$anm22.tableClasses.foodPermission().getAll();
      if(!this.license.config.modules.fastCash.enabled) {
        delete(permissions[5]);
      }
      if(!this.license.config.modules.tables.enabled) {
        delete(permissions[4]);
        delete(permissions[6]);
      }
      Object.keys(permissions).filter(p => p < this.permission).forEach(p => delete(permissions[p]));
      return permissions;
    }
  },
  methods: {
    async createUser() {
      this.newUserErrors = [];
      // verify all data compiled
      if(this.newUser.name === '') { 
        this.newUserErrors.push('name');
      }
      if(this.newUser.surname === '') {
        this.newUserErrors.push('surname');
      }
      if(this.newUser.email === '') {
        this.newUserErrors.push('email');
      }
      if(this.newUser.password === '') {
        this.newUserErrors.push('password');
      }
      
      if(this.newUserErrors.length > 0) {
        return;
      }

      try{
        const response = await this.$http.post('settings/create-user', {
          newUser: this.newUser
        });
        Promise.all([
          this.$store.dispatch("foodEmployments/update", {
            vlf: this.$vlf("foodEmployments"),
            objs: [response.data.employment]
          }),
          this.$store.dispatch("users/update", {
            vlf: this.$vlf("users"),
            objs: [response.data.user]
          })
        ]);
      } catch (e) {}
      finally {
        this.showUserDialog = false;
        this.newUserErrors = {
          name: '',
          surname: '',
          email: '',
          pass: ''
        };
      }
    },
    add() {
      //Aggiunta amministratore
      this.$http
        .post('settings/add-admin', {
          admin: this.newAdmin
        })
        .then(response => {
          console.log(response.data);
          if(response.data.user) {
            Promise.all([
              this.$store.dispatch("foodEmployments/update", {
                vlf: this.$vlf("foodEmployments"),
                objs: [response.data.employment]
              }),
              this.$store.dispatch("users/update", {
                vlf: this.$vlf("users"),
                objs: [response.data.user]
              })
            ]);
            this.$anm22.eventBus.$emit("world-headbar-show-message", {
              text: this.$anm22.strLang(
                this.lang,
                "Admin correctly added",
                "Amministratore aggiunto correttamente"
              ),
              type: "confirm"
            });
          } else {
            if(response.data.employment) {
              this.$anm22.eventBus.$emit("world-headbar-show-message", {
                text: this.$anm22.strLang(
                  this.lang,
                  "Admin already added",
                  "Amministratore già presente"
                ),
                type: "alarm"
              });
            } else {
              // User not registered on the platform
              Object.assign(this.newUser, this.newAdmin);
              this.showUserDialog = true;
            }
          }
        })
        .catch(e => {})
        .finally(() => {
          this.newAdmin = {
            email: '',
            permission: 5,
            pin: ''
          };
        });
    },
    edit() {
      this.$http
        .post('settings/edit-admin', {
          user: this.selected.user.idWorldUser,
          permission: this.selected.permission,
          pin: this.selected.pin
        })
        .then(response => {
          this.$store.dispatch("foodEmployments/update", {
            vlf: this.$vlf("foodEmployments"),
            objs: [response.data.employment]
          });
          this.closeAdminDialog();
        })
        .catch(e => {});
    },
    deleteAdmin() {
      this.$http
        .post('settings/delete-admin', {
          user: this.selected.user
        })
        .then(response => {
          this.$store.dispatch("foodEmployments/delete", {
            vlf: this.$vlf("foodEmployments"),
            obj: this.selected
          });
          this.closeDeleteDialog();
        })
        .catch(e => {});
    },
    openAdminDialog(employment) {
      this.selected = employment;
      this.showAdminDialog = true;
    },
    closeAdminDialog() {
      this.showAdminDialog = false;
      this.selected = null;
    },
    openDeleteDialog(employment) {
      this.selected = employment;
      this.showDeleteDialog = true;
    },
    closeDeleteDialog() {
      this.showDeleteDialog = false;
      this.selected = null;
    }
  },
  created() {
    this.$Progress.start();
    // Blocco l'accesso se ho un permesso di basso livello o se la licenza è una delle demo e il permesso non è superuser
    if(this.permission > 3 
        || (this.permission !== 1 && (this.license.work === 1 || this.license.work === 2 || this.license.work === 289))) {
      this.$router.push('/').catch(e => console.log(e));
      return;
    }
    this.$http.get('settings/admin')
      .then(response => {
        Promise.all([
          this.$store.dispatch("foodEmployments/update", {
            vlf: this.$vlf("foodEmployments"),
            objs: response.data.employments
          }),
          this.$store.dispatch("users/update", {
            vlf: this.$vlf("users"),
            objs: response.data.users
          }),
        ])
        .then(() => {
          this.$Progress.finish();
        })
      });
  }
}
</script>

<style lang="scss" scoped>
.support-label {
  border:1px solid #666;
  color:#666;
  border-radius:4px;
  font-size:12px;
  padding:2px 4px;
  width:60px;
}
</style>
